

import React, { Component } from "react";
import { translations } from "../../../../translate";
import { Col, Row, Progress } from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
import { Picky } from "react-picky";
import "react-picky/dist/picky.css";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import DeleteIcon from "@material-ui/icons/Delete";
import PublishIcon from "@material-ui/icons/Publish";
import { CircularProgress, Checkbox, FormControlLabel } from "@material-ui/core";
let Strings =
    localStorage.getItem("LANG") == 1 ? translations.Ar : translations.En;
var today = new Date();
var currentDate =
    today.getFullYear() +
    "-" +
    ("0" + (today.getMonth() + 1)).slice(-2) +
    "-" +
    ("0" + today.getDate()).slice(-2);

export default class ServicePermissions extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: 0,
            errMessage: "",
            password: "",
            confirmPassword: "",
            formError: "",
            amount: "",
            progressUploadHeader: "",
            displayErrorHeaderMsg: "",
            fileName: "",
            fileSize: "",
            submitError: "",
            currencyList: [],
            currency: "",
            currencyId: "",
            posId: this.props.posData.userId,
            selectedFile: null,
            allowEditEfwatercom: this.props.allowEditEfwatercom || 0,
            allowEditUmniah: this.props.allowEditUmniah || 0,

            allowEfwateercomForPos: this.props.posData.allowEfwateercomForPos || 0,
            allowUmniahForPos: this.props.posData.allowUmniahForPos || 0,

        };
    }
    submitHandler = async () => {
        this.setState({ submitError: "", loading: 1, startSave: 1 });

        this.setState({ startSave: 1 });

        fetch(window.API_PERM_USER, {
            method: "POST",
            body: JSON.stringify({
                type: "updatePosPaymentMethodCommission",
                userId: localStorage.getItem("USER_ID"),
                token: localStorage.getItem("USER_TOKEN"),
                lang: localStorage.getItem("LANG"),
                posId: this.state.posId,
                allowEfwateercomForPos: this.state.allowEfwateercomForPos,
                allowUmniahForPos: this.state.allowUmniahForPos,
            }),
            headers: {
                Accept: "application/json",
            },
        })
            .then(function (response) {
                if (!response.ok) {
                    console.log(response.statusText);
                }
                return response.json();
            })
            .then((data) => {
                if (data !== "Nothing found") {
                    if (data["logout"] == 1) {
                        localStorage.setItem("USER_ID", "");
                        localStorage.setItem("USER_TOKEN", "");
                        window.location.href = "/logout";
                    } else if (data["error"] == 1) {
                        this.setState({ submitError: data["errorMsg"] });
                        console.log(data["errorMsg"]);

                    } else {
                        this.setState({ loading: 0 });
                        this.props.handleCloseSideBar();
                    }
                }
            });
        this.setState({ startSave: 0 });
    };






    componentDidMount() {

    }


    render() {
        return (
            <div className="view-modal-style">
                <div className="sidebar-header-view">
                    <Row>
                        <Col lg={10} md={10} sm={10} xs={10}>
                            <div className="p-0 main-color-1  sidebar-header-title">
                                {`${Strings["Service Permissions"]}`}
                            </div>
                        </Col>
                        <Col lg={2} md={2} sm={2} xs={2} className="text-right">
                            <HighlightOffIcon
                                onClick={this.props.handleCloseSideBar}
                                className="modal-close-icon"
                            />
                        </Col>
                    </Row>
                </div>
                <div className="sidebar-body-view">
                    {this.state.loading == 1 && (
                        <Row>
                            <Col md={12} style={{ marginTop: "15%" }} className="text-center">
                                <div className="card-body">
                                    <div
                                        className="spinner-grow text-dark m-2 main-color-1"
                                        role="status"
                                    ></div>
                                    <div
                                        className="spinner-grow text-dark m-2 main-color-2"
                                        role="status"
                                    ></div>
                                    <div
                                        className="spinner-grow text-dark m-2 main-color-1"
                                        role="status"
                                    ></div>
                                    <div
                                        className="spinner-grow text-dark m-2 main-color-2"
                                        role="status"
                                    ></div>
                                    <div
                                        className="spinner-grow text-dark m-2 main-color-1"
                                        role="status"
                                    ></div>
                                    <div
                                        className="spinner-grow text-dark m-2 main-color-2"
                                        role="status"
                                    ></div>
                                </div>
                            </Col>
                        </Row>
                    )}
                    {this.state.loading == 0 && (
                        <React.Fragment>
                            <Row>
                                <Col lg={12} md={12} sm={12} xs={12}>
                                    <AvForm onSubmit={this.submitHandler}>
                                        <Row>

                                            <Col lg={12} md={12} sm={12} xs={12}>
                                                {(localStorage.getItem("USER_LEVEL") == 1 || this.state.allowEditEfwatercom == 1) && (
                                                    <div className="form-group mb-0">
                                                        <FormControlLabel
                                                            label={
                                                                <>
                                                                    <label className="font-w-400">
                                                                        {Strings["Allow work with e-fawatercom"]}
                                                                    </label>
                                                                </>
                                                            }
                                                            control={
                                                                <Checkbox
                                                                    color="primary"
                                                                    name="allowEfwateercomForPos"
                                                                    // onBlur={handleBlur}
                                                                    onChange={() => {
                                                                        this.setState({
                                                                            allowEfwateercomForPos: this.state.allowEfwateercomForPos == 1 ? 0 : 1,
                                                                        });
                                                                    }}
                                                                    checked={this.state.allowEfwateercomForPos == 1}
                                                                />
                                                            }
                                                        />
                                                    </div>
                                                )}

                                            </Col>
                                            <Col lg={12} md={12} sm={12} xs={12}>
                                                {(localStorage.getItem("USER_LEVEL") == 1 || this.state.allowEditUmniah == 1) && (
                                                    <div className="form-group mb-0">
                                                        <FormControlLabel
                                                            label={
                                                                <>
                                                                    <label className="font-w-400">
                                                                        {Strings["Allow work with Umniah"]}
                                                                    </label>
                                                                </>
                                                            }
                                                            control={
                                                                <Checkbox
                                                                    color="primary"
                                                                    name="allowUmniahForPos"
                                                                    // onBlur={handleBlur}
                                                                    onChange={() => {
                                                                        this.setState({
                                                                            allowUmniahForPos: this.state.allowUmniahForPos == 1 ? 0 : 1,
                                                                        });
                                                                    }}
                                                                    checked={this.state.allowUmniahForPos == 1}
                                                                />
                                                            }
                                                        />
                                                    </div>
                                                )}


                                            </Col>

                                            <Col lg={12} md={12} sm={12} xs={12} className="mt-3">
                                                {this.state.startSave == 1 ? (
                                                    <button
                                                        type="button"
                                                        className="btn form-save-btn mt-2"
                                                    >
                                                        {" "}
                                                        <CircularProgress className="SaveCircularProgressColor" />
                                                        {Strings["Save"]}{" "}
                                                    </button>
                                                ) : (
                                                    <button
                                                        type="submit"
                                                        className="btn form-save-btn mr-1 ml-1 mt-2"
                                                    >
                                                        {" "}
                                                        {Strings["Save"]}{" "}
                                                    </button>
                                                )}
                                            </Col>
                                            {this.state.formError && (
                                                <Col lg={12} md={12} sm={12} xs={12}>
                                                    <p className="invalid-feedback d-block mb-1">
                                                        {this.state.formError}
                                                    </p>
                                                </Col>
                                            )}
                                            {this.state.submitError && (
                                                <div className="error-text-black mt-3">
                                                    <i className="flaticon2-exclamation error-icon mr-1" />{" "}
                                                    {this.state.submitError}
                                                </div>
                                            )}
                                        </Row>
                                    </AvForm>
                                </Col>
                            </Row>
                        </React.Fragment>
                    )}
                </div>
            </div>
        );
    }
}
